import React, { Suspense, lazy, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Loader from './components/common/Loader';
import './styles/main.scss';
const Status = lazy(() => import('./components/status/status'));
const BookingStatus = lazy(() => import('./components/status/booking/BookingStatus'));
const BookingDetails = lazy(() => import('./components/status/booking/BookingDetails'));
const PaymentDetails = lazy(() => import('./components/status/payment/paymentDetails'));
const PaymentStatus = lazy(() => import('./components/status/payment/PaymentStatus'));
const TripStatus = lazy(() => import('./components/status/trip/TripStatus'));
const TripCards = lazy(() => import('./components/status/trip/TripCards'));
const TripStatusDetails = lazy(() => import('./components/status/trip/tripStatusDetails'));
const WLBookingStatus = lazy(() => import('./components/status/waitlist-booking/BookingStatus'));
const WLBookingDetails = lazy(() => import('./components/status/waitlist-booking/BookingDetails'));

function App() {
  return (
    <Router >
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/status" element={<Status />} />
            <Route path="/status/booking" element={<BookingStatus />} />
            <Route path="/status/booking/:id" element={<BookingDetails />} />
            <Route path="/status/payment" element={<PaymentStatus />} />
            <Route path="/status/payment/:id" element={<PaymentDetails />} />
            <Route path="/status/trip" element={<TripStatus />} />
            <Route path="/status/trip/:id" element={<TripStatusDetails />} />
            <Route path="/status/waitlist-booking" element={<WLBookingStatus />} />
            <Route path="/status/waitlist-booking/:id" element={<WLBookingDetails />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Router>
  );
}

class ErrorBoundary extends React.Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

const ErrorPage = () => (
  <div className='err-screen'>
    Oops! some error occured!
    <br />
    <br />
    <a href='/' target='_self'>GO TO HOME</a>
  </div>
)

export default App;
